module.exports = __webpack_public_path__ + "static/media/text_w.2b4a3d58.svg";